export const locationNotes = {
	title: "Notas de Alquiler",
	filename: "notas-de-alquiler",
	table: {
		serialNumber: "Número",
		issueDate: "Fecha de emisión",
		period: "Período",
		status: "Estado",
		value: "Valor",
		generatedAs: "Generado como",
		pdf: "PDF",
		noAttachments: "Sin anexos",
		attachments: "Anexos",
	},
	status: {
		created: "Creado",
		generated: "Generado",
		cancelled: "Cancelado",
	},
	generated: {
		automatic: "Automático",
		manually: "Manualmente",
	},
	emptyText: "No hay nada que mostrar para el período seleccionado",
};
